// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"69726aed","897":"fc0d20db"}[chunkId] + ".chunk.css";
};